module.exports = new Promise((resolve, reject) => {
      if (!window.__REMOTES__) return reject(new Error('__REMOTES__ not initialized'));
      var url = window.__REMOTES__['fusion'];
      if (!url) return reject(new Error('No remote URL for fusion'));
      if (window['fusion']) return resolve(window['fusion']);
      var script = document.createElement('script');
      script.src = url;
      script.onload = function() { resolve(window['fusion']); };
      script.onerror = function() { reject(new Error('Failed to load ' + url)); };
      document.head.appendChild(script);
    });